import { useState } from 'react';
import { MapPin, Loader2 } from 'lucide-react';
import { LocationData } from '../../types/fieldResearch';

interface Props {
  location: LocationData;
  onCapture: (location: LocationData) => void;
}

export default function LocationCapture({ location, onCapture }: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const capture = () => {
    if (!navigator.geolocation) {
      setError('Geolocalização não suportada neste dispositivo.');
      return;
    }
    setLoading(true);
    setError('');
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        onCapture({ lat: pos.coords.latitude, lng: pos.coords.longitude });
        setLoading(false);
      },
      () => {
        setError('Não foi possível obter a localização. Verifique as permissões.');
        setLoading(false);
      },
      { enableHighAccuracy: true, timeout: 10000 },
    );
  };

  return (
    <div className="space-y-3">
      <h2 className="text-sm font-bold text-white">Localização</h2>
      <button
        type="button"
        onClick={capture}
        disabled={loading}
        className="w-full flex items-center justify-center gap-2 bg-blue-600/15 border border-blue-500/30 text-blue-300 py-3 rounded-xl text-sm font-medium hover:bg-blue-600/25 transition disabled:opacity-50 active:scale-95"
      >
        {loading ? (
          <Loader2 size={16} className="animate-spin" />
        ) : (
          <MapPin size={16} />
        )}
        {loading ? 'Capturando...' : 'Capturar localização atual'}
      </button>

      {location.lat !== null && (
        <div className="flex items-center gap-2 bg-blue-500/10 border border-blue-500/20 rounded-xl px-4 py-2.5 text-xs text-blue-300">
          <MapPin size={13} className="shrink-0" />
          <span>
            {location.lat.toFixed(6)}, {location.lng?.toFixed(6)}
          </span>
        </div>
      )}

      {error && (
        <p className="text-xs text-red-400 text-center">{error}</p>
      )}
    </div>
  );
}
